import { postApiSharepointUploadPhotoProjectId } from "../../../api/generated/endpoints/share-point/share-point";
import { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { CameraOutlined } from "@ant-design/icons";
import { SelfControlItem } from "../../../api";
import "./SelfControlCard.css";
import { toastError, toastSuccess } from "../../../utilities/messageUtils";
import StbButton from "../../atoms/button/StbButton";

interface SelfControlItemProp {
  selfControlItem: SelfControlItem;
  projectId: number;
  onUpdate: (updatedItem: Partial<SelfControlItem>) => void;
}

const SelfControlCard: React.FC<SelfControlItemProp> = (props) => {
  const cameraInputRef = useRef<HTMLInputElement | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const isApproved = props.selfControlItem.approved ?? false;

  const handleChange = (updatedData: Partial<SelfControlItem>) => {
    props.onUpdate(updatedData);
  };

  const openCameraPicker = () => {
    cameraInputRef.current?.click();
  };

  const handleFilesSelected = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    try {
      setIsUploading(true);

      await postApiSharepointUploadPhotoProjectId(props.projectId, {
        File: file,
        RequirementTitle: props.selfControlItem.title ?? "Foto",
      });

      toastSuccess("Bilden har laddats upp till SharePoint.");
    } catch (error) {
      console.error("Fel vid bilduppladdning:", error);
      toastError("Det gick inte att ladda upp bilden.", error);
    } finally {
      setIsUploading(false);
      event.target.value = "";
    }
  };

  return (
    <div className="sc-checkpoint-row">
      <div className="sc-header-row">
        <Form.Label className="sc-card-title mb-0">
          {props.selfControlItem.title}
        </Form.Label>

        <div className="sc-actions">
          <StbButton
            type="button"
            variant="toggle"
            size="sm"
            className={isApproved ? "is-on" : ""}
            onClick={() => handleChange({ approved: !isApproved })}
            aria-pressed={isApproved}
          >
            GODKÄND
          </StbButton>

          <StbButton
            type="button"
            variant="ghost"
            size="sm"
            icon
            onClick={openCameraPicker}
            title="Ladda upp foto"
            aria-label="Ladda upp foto"
            disabled={isUploading}
          >
            <CameraOutlined aria-hidden="true" />
          </StbButton>

          <input
            ref={cameraInputRef}
            type="file"
            accept="image/*"
            capture="environment"
            style={{ display: "none" }}
            onChange={handleFilesSelected}
          />
        </div>
      </div>

      <Form.Text className="sc-description">
        {props.selfControlItem.description}
      </Form.Text>

      <div className="sc-checkpoint-remark">
        <Form.Control
          defaultValue={props.selfControlItem.remark ?? undefined}
          onChange={(event) => {
            handleChange({ remark: event.target.value });
          }}
          className="sc-form-control"
          placeholder="Anm:"
        />
      </div>

      {isUploading && (
        <div className="sc-uploading">
          <small>Laddar upp bild...</small>
        </div>
      )}
    </div>
  );
};

export default SelfControlCard;